import { createSelector } from '@reduxjs/toolkit';
import { compareAsc } from 'date-fns';

import { SystemNotificationsViewModel } from '../../models/notifications/Notifications';
import { AppState } from '../reducers/root';

export const getSystemNotifications = (
  state: AppState
): SystemNotificationsViewModel => state.systemNotifications;

export const getSystemNotificationsSortedByStartTs = createSelector(
  getSystemNotifications,
  systemNotifications =>
    Object.values(systemNotifications)
      .filter(({ toShow }) => toShow)
      .sort((a, b) => compareAsc(a.startTs, b.startTs))
);

export const hasSystemNotifications = createSelector(
  getSystemNotifications,
  systemNotifications => Object.keys(systemNotifications).length > 0
);

export const getExpiredSystemNotificationIds = createSelector(
  getSystemNotifications,
  (_state: AppState, date: Date) => date,
  (systemNotifications, date) =>
    Object.keys(systemNotifications).filter(
      id => systemNotifications[id].finishTs <= date
    )
);
